export default {
  setLoading(isLoading, next) {
    let state = next || this.getState();

    state = state.set('loading', isLoading);

    this.setStateAndTrigger(state);
  },
};
